<template>
  <div class="home">
    <h1>Circle list searcher</h1>
    <p>
      <i class="large material-icons">search</i><br>
      即売会のサークルリストを検索するツール
    </p>
    <h3>COMITIA</h3>
    <ul>
      <li><h5><router-link to="/list/comitia/index">INDEX</router-link></h5></li>
    </ul>
    <h3>Latest event</h3>
      <ul>
        <li><h5><router-link to="/list/comitia/134">COMIOTIA (134)</router-link></h5></li>
      </ul>
    <h3>Other tools</h3>
    <ul>
      <li><a href="https://gitlab.com/comitia-tools/circle-list-extract" target="_blank" rel="noopener">Circle list extract</a> コミティアのサークルリストを抽出</li>
    </ul>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  title: 'Home',
  name: 'home',
  components: {
  }
}
</script>

<style>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
